import { Location } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
	ArrowLeftSvgComponent,
	ExclamationMarkTriangularSvgComponent,
} from '@uc/shared/svg';

@Component({
	selector: 'uc-course-search-error',
	templateUrl: './course-search-error.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [ExclamationMarkTriangularSvgComponent, ArrowLeftSvgComponent],
})
export class CourseSearchErrorComponent {
	private _location = inject(Location);

	onBack() {
		this._location.back();
		setTimeout(() => location.reload(), 20);
	}
}
